/** Skeleton das Notas fiscais — header + navegador de mês + lista. */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-5xl animate-pulse flex-col gap-6">
      <div className="h-4 w-24 rounded bg-slate-100" />
      <div className="h-[104px] rounded-[20px] bg-slate-200" />
      <div className="h-11 rounded-xl bg-slate-100" />
      <div className="flex flex-col gap-2">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="flex items-center justify-between rounded-xl border border-slate-200 bg-white p-3">
            <div className="space-y-1.5">
              <div className="h-4 w-44 rounded bg-slate-200" />
              <div className="h-3 w-56 rounded bg-slate-100" />
            </div>
            <div className="h-8 w-28 rounded-lg bg-slate-100" />
          </div>
        ))}
      </div>
    </div>
  );
}
